export var createEmailTemplatesApi = function (baseUrl, http) {
    return {
        getEmailTemplates: function (dto) {
            return http.get(baseUrl + "/emailTemplates/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        getEmailTemplate: function (dto) {
            return http.get(baseUrl + "/emailTemplates/" + dto.locale + "/" + dto.type + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        updateEmailTemplate: function (dto) {
            return http.put(baseUrl + "/emailTemplates/" + dto.locale + "/" + dto.type, dto.data);
        },
        getDefaultEmailTemplate: function (dto) {
            return http.get(baseUrl + "/emailTemplates/" + dto.locale + "/" + dto.type + "/default" + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        enableEmailTemplate: function (dto) {
            return http.put(baseUrl + "/emailTemplates/notifications/" + dto.locale + "/" + dto.type + "/enable" + (dto.brandId ? "?brandId=" + dto.brandId : ''), {});
        },
        disableEmailTemplate: function (dto) {
            return http.put(baseUrl + "/emailTemplates/notifications/" + dto.locale + "/" + dto.type + "/disable" + (dto.brandId ? "?brandId=" + dto.brandId : ''), {});
        }
    };
};
//# sourceMappingURL=index.js.map